import { useChatContext } from '@/contexts/ChatContext';

export const useChatSystem = () => {
  const context = useChatContext();

  return {
    openChatWithUser: context.openChatWithUser,
    conversations: context.conversations,
    openChats: context.openChats,
    sendMessage: context.sendMessage,
    toggleChat: context.toggleChat,
    closeChat: context.closeChat,
    openAtlasChat: context.openAtlasChat,
    forceOpenAtlas: context.forceOpenAtlas,
    atlasConversation: context.atlasConversation,
    atlasOpenSignal: context.atlasOpenSignal,
    sendAtlasMessage: context.sendAtlasMessage,
    addAtlasMessage: context.addAtlasMessage,
    clearAtlasLoadingMessages: context.clearAtlasLoadingMessages,
    atlasDockOpen: context.atlasDockOpen,
    openAtlasDock: context.openAtlasDock,
    closeAtlasDock: context.closeAtlasDock,
    atlasCreditsExhausted: context.atlasCreditsExhausted,
  };
};
